export const isIntercomAvailable = () =>
  typeof window.Intercom === "function" && window.Intercom.booted === true;

export const showNewIntercomMessage = (message: string) => {
  if (!isIntercomAvailable()) {
    return;
  }
  window.Intercom("showNewMessage", message);
};
